import { observer } from 'mobx-react-lite';
import { CustomFormPage } from 'src/components/FormPages/CustomFormPage';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { SettingsInterestRateStore } from 'src/stores/SettingsStores/SettingsInterestRateStore/SettingsInterestRateStore';

export const InterestRateDetails = observer(() => {
    return (
        <CustomFormPage
            pageName="setting-interest-rate"
            store={SettingsInterestRateStore}
            baseUrl={RoutePaths.settingsInterestRate}
            data-testid="settings-interest-rate"
        />
    );
});
